export default function PageHero({ overline, title, accent, body, image, testid = "page-hero" }) {
  return (
    <section data-testid={testid} className="relative pt-40 pb-20 md:pt-48 md:pb-28 overflow-hidden">
      {image && (
        <div className="absolute inset-0 -z-10">
          <img src={image} alt="" className="w-full h-full object-cover opacity-30" />
          <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A]/40 via-[#0A0A0A]/70 to-[#0A0A0A]" />
        </div>
      )}
      <div className="max-w-[1400px] mx-auto px-6 md:px-10 grid md:grid-cols-12 gap-8">
        <div className="md:col-span-9">
          <div className="overline mb-6">{overline}</div>
          <h1 className="font-serif text-5xl sm:text-6xl md:text-7xl lg:text-[6rem] leading-[0.95] tracking-tighter text-[#EAEAEA]">
            {title}
            {accent && (
              <>
                <br />
                <span className="text-[#B58B5D] italic">{accent}</span>
              </>
            )}
          </h1>
          {body && (
            <p className="mt-10 text-lg md:text-xl text-[#A3A3A3] max-w-2xl leading-relaxed">
              {body}
            </p>
          )}
        </div>
      </div>
    </section>
  );
}
